module.exports = __webpack_public_path__ + "img/emall.da1bddbf.png";